import { alternativeSubtitle, alternativeTitle } from "../../configs/vitrine"
import { filterByShowcasesShown } from "./showcaseFilters";

export const showcaseBuilder = (data) => {
    if(!data){
      return []
    }
    const dataFormatted =  data.map((vitrine) => {
      return {
        id: vitrine.id,
        feature: vitrine.feature,
        title: vitrine.title || alternativeTitle[vitrine.feature] || null,
        subtitle: vitrine.subtitle || null,
        recommendations: vitrine.displays[0].recommendations || null,
      }
    });

    return filterByShowcasesShown(dataFormatted);
  }
